import { memo } from 'react';
import { IVideoPlayerProps } from './VideoPlayer.types';

export const VideoPlayer = memo<IVideoPlayerProps>(({ webpSrc, mp4Src, poster, className }) => (
  <video
    className={className}
    autoPlay
    loop
    preload="auto"
    muted
    poster={poster}
    controls={false}
    playsInline
  >
    <track kind="captions" />
    <source src={webpSrc} type="video/webm" />
    <source src={mp4Src} type="video/mp4" />
  </video>
));

VideoPlayer.displayName = 'VideoPlayer';

export default VideoPlayer;
